/**
 * Where a runtime map overlay inserts its layers.
 *
 * LAYER-ORDERING-CRITICAL.md Rule 2 (docs/modules/maplibre/): the 3D buildings
 * (fill-extrusion) are always in the style, hidden until 2.5D is on, so a layer
 * APPENDED at runtime lands above them and shows through the buildings once the
 * user tilts. Every overlay therefore inserts before the first extrusion layer —
 * the NG promet overlays, the OPT gap rings, the EK path and address layers, and
 * the tenant's custom layers in MapManager (its fallback after the Naslovi labels).
 *
 * Moved here from `unified/v6/components/NgPrometPanel/overlayLayers.ts` (where
 * `removeOverlay` still lives) because it is not a Promet rule.
 */

import type maplibregl from 'maplibre-gl';

/**
 * The layer to insert before so that a new layer lands under the 3D
 * buildings; `undefined` when the style has no extrusion (the layer is then
 * appended).
 */
export function firstExtrusionLayerId(map: maplibregl.Map): string | undefined {
  return map.getStyle()?.layers?.find((l) => l.type === 'fill-extrusion')?.id;
}
